const tables = [
  {
    name: "Name",
  },
  {
    name: "Title",
  },
  {
    name: "Description",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
